/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Canceldeal_Modal_Validationword3Inputs */

const en_coinvestments_canceldeal_modal_validationword3 = /** @type {(inputs: Coinvestments_Canceldeal_Modal_Validationword3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cancel`)
};

/**
* | output |
* | --- |
* | "cancel" |
*
* @param {Coinvestments_Canceldeal_Modal_Validationword3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_canceldeal_modal_validationword3 = /** @type {((inputs?: Coinvestments_Canceldeal_Modal_Validationword3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Canceldeal_Modal_Validationword3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_canceldeal_modal_validationword3(inputs)
});
export { coinvestments_canceldeal_modal_validationword3 as "coInvestments_cancelDeal_modal_validationWord" }